import { render, staticRenderFns } from "./list.vue?vue&type=template&id=19e6c450&scoped=true"
import script from "./list.js?vue&type=script&lang=js&external"
export * from "./list.js?vue&type=script&lang=js&external"
import style0 from "./list.vue?vue&type=style&index=0&id=19e6c450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e6c450",
  null
  
)

export default component.exports